import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import Icon from "../components/Icon";
import IngredientGroups from "../components/IngredientGroups";
import { INGREDIENTS } from "../data/content";
import { TOTAL_ACTIVES, TOTAL_SYSTEMS } from "../data/ingredients";

const Ingredients = () => (
  <div>
    <PageHero
      overline="Ingredients"
      title="Inside every sachet."
      subtitle="Premium ingredients. Purposeful blends. Proven results. We blend clinically-studied actives in their most bioavailable forms — nothing hidden, nothing unnecessary."
      image="/images/ingredients_collage.png"
      imageAlt="Ingredients collage"
    />

    {/* STATS STRIP */}
    <section className="max-w-7xl mx-auto px-4 md:px-8 pt-16">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {[
          [`${TOTAL_ACTIVES}+`, "Active Ingredients"],
          [`${TOTAL_SYSTEMS}`, "Systems Supported"],
          ["0", "Proprietary Blends"],
          ["100%", "Label Transparency"],
        ].map(([v, l]) => (
          <Reveal key={l}>
            <div className="rounded-3xl bg-white border border-slate-100 p-6 text-center shadow-[0_8px_30px_rgb(15,23,42,0.04)]">
              <p className="font-heading text-3xl md:text-4xl font-bold text-navy-900">{v}</p>
              <p className="text-xs text-slate-400 mt-1">{l}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    {/* FULL FORMULA ACCORDION */}
    <section className="max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-20">
      <Reveal className="mb-10">
        <span className="text-xs font-bold tracking-[0.22em] uppercase text-royal mb-3 block">The Full Formula</span>
        <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-navy-900">Every active ingredient.</h2>
        <p className="mt-4 text-slate-500 leading-relaxed">Organised by the systems they support. Tap any category to reveal the complete breakdown.</p>
      </Reveal>
      <IngredientGroups defaultOpen={0} showAmount={false} />
    </section>

    {/* HIGHLIGHTS */}
    <section className="bg-[#FAFBFD] border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <Reveal className="max-w-2xl mb-12">
          <span className="text-xs font-bold tracking-[0.22em] uppercase text-royal mb-3 block">Hero Ingredients</span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-navy-900">The pillars of the formula.</h2>
        </Reveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {INGREDIENTS.map((ing, i) => (
            <Reveal key={ing.name} delay={i * 0.06}>
              <div className="group bg-white rounded-3xl p-8 border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 h-full">
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-sky-50 text-royal group-hover:bg-royal group-hover:text-white transition-colors mb-6">
                  <Icon name={ing.icon} className="w-7 h-7" />
                </span>
                <h3 className="font-heading text-xl font-semibold text-navy-900">{ing.name}</h3>
                <p className="text-slate-500 mt-3 leading-relaxed">{ing.desc}</p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.3}>
            <div className="rounded-3xl p-8 bg-gradient-to-br from-royal to-navy-900 text-white h-full flex flex-col justify-center">
              <h3 className="font-heading text-xl font-semibold">Clean & Transparent</h3>
              <p className="text-slate-300 mt-3 leading-relaxed text-sm">
                No proprietary blends. No fillers. Full ingredient disclosure on every batch, third-party tested for purity and potency.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  </div>
);

export default Ingredients;
